import type { Components, CSSObject, Theme } from '@mui/material/styles';

import palette from '@/theme/palette';
import typography from '@/theme/typography';

declare module '@mui/material/Avatar' {
  interface AvatarPropsVariantOverrides {
    'talent-xsmall': true;
    'talent-large': true;
    'user-small': true;
  }
}

const initialsStyles: CSSObject = {
  color: palette.background.default,
  backgroundColor: palette.primary[200]
};

const userInitialsStyles: CSSObject = {
  fontFamily: 'Poppins',
  fontWeight: typography.fontWeightRegular
};

const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  variants: [
    {
      props: { variant: 'talent-xsmall' },
      style: { height: 32, width: 32, ...initialsStyles, ...typography.body1 }
    },
    {
      props: { variant: 'talent-large' },
      style: {
        height: 96,
        width: 96,
        fontSize: '3rem',
        ...initialsStyles
      }
    },
    {
      props: { variant: 'user-small' },
      style: ({ theme: { spacing } }) => ({ height: 20, width: 20, ...userInitialsStyles, fontSize: spacing(1.25) })
    }
  ]
};

export default MuiAvatar;
